import { IOfficeAppliancesType } from "../types/index";
import { updateType } from "../api/updateType";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "components/toastNotification";

const useUpdateType = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation(
    (typeNewData: IOfficeAppliancesType) => updateType(typeNewData),
    {
      onSuccess: (res) => {
        if (res === "Duplicate") {
          toast.fire("Failed", "Type already exist", "error");
        } else {
          toast.fire("Success", "Type updated successfully", "success");
        }
        queryClient.invalidateQueries(["GetTypes"]);
      },
      onError: () => {
        toast.fire("Failed", "Failed to update Type", "error");
      },
    }
  );
  return mutate;
};
export default useUpdateType;
